import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Stepper } from "@mui/material";
import { useAppSelector } from "../../../infra/hooks";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import { fonts } from "../../themes/themes";
import moment from "moment";

interface contentTileType {
  review_heading: string;
  review_value: string;
  date: any;
}
const ReviewTile: React.FC<contentTileType> = ({
  review_heading,
  review_value,
  date,
}) => {
  return (
    <Box
      style={{
        backgroundColor: "#FAFAFA",
        borderRadius: "1em",
        padding: "0.5em",
      }}
    >
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          style={{
            fontSize: "0.85em",
            color: "#1C1D21",
            fontWeight: "bold",
            fontFamily: fonts.fontFamily,
          }}
        >
          {review_heading}
        </Typography>
        <Typography
          style={{
            fontSize: "0.725em",
            color: "#4CAF50",
            fontFamily: fonts.fontFamily,
          }}
        >
          {review_value}
          {"% Completed"}
        </Typography>
      </Box>

      <Box style={{ marginTop: "0.5em" }}>
        <LinearProgress
          variant="determinate"
          value={49}
          sx={{
            "&.MuiLinearProgress-root": {
              backgroundColor: "#E6E8F0",
            },
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#4CAF50",
              boxShadow: "#00000029",
            },
          }}
        />
      </Box>
      <Box style={{ marginTop: "0.5em" }} />
      <Box>
        <Typography
          style={{
            fontSize: "0.65em",
            color: "#9E9E9E",
            fontWeight: "bold",
            fontFamily: fonts.fontFamily,
          }}
        >
          Completed: {moment(date).format("DD/MM/YYYY")}
        </Typography>
      </Box>
    </Box>
  );
};

export default ReviewTile;
